import { SearchOutlined } from '@ant-design/icons';
import { Col, Input, Row, Select, Space } from 'antd';
import styles from './index.module.scss';
import './index.scss';
import ClearFilter from 'components/Global/ClearFilter';
import { SearchAndFilterProps } from './types';
import { EJournalStatus } from 'constants/Data';
import { DatePicker } from 'antd';

const SearchAndFilter = (props: SearchAndFilterProps) => {
	const {
		searchValue,
		performSearchHandler,
		filterValue,
		performFilterHandler,
		clearFilter,
		handleYear,
		year,
	} = props;

	const handleChangeSearchValue = (value: any) => {
		performSearchHandler && performSearchHandler(value);
	};

	return (
		<div className={styles['search-filter']}>
			<div className={styles['search-filter__wrapper']}>
				<Row justify="space-between" align="middle" gutter={[16, 16]}>
					<Col>
						<Space wrap>
							<Input
								className={styles['search-filter__search']}
								placeholder="Search here..."
								style={{ fontSize: '12px', minHeight: '40px', minWidth: 200 }}
								suffix={<SearchOutlined />}
								onChange={(e) => handleChangeSearchValue(e.target.value)}
								value={searchValue}
								size="large"
							/>

							<Select
								className={styles['search-filter__filter']}
								style={{ minWidth: 200 }}
								size="large"
								placeholder="Status"
								showSearch
								value={filterValue?.status}
								filterOption={(input, option: any) =>
									(option?.children as string)
										.toLowerCase()
										.indexOf(input.toLowerCase()) >= 0
								}
								onChange={(value) => performFilterHandler('status', value)}
							>
								<Select.Option value="">Select Status</Select.Option>
								<Select.Option value={EJournalStatus.PUBLISHED}>
									Published
								</Select.Option>
								<Select.Option value={EJournalStatus.DRAFT}>
									Draft
								</Select.Option>
								<Select.Option value={EJournalStatus.DELETED}>
									Deleted
								</Select.Option>
							</Select>

							{/* Uncomment if needed later */}
							{/* <PayPeriodFilter
				payPeriodId={selectedPayPeriod}
				onChangePayPeriodId={onChangePayPeriod}
			/> */}

							<DatePicker
								size="large"
								picker="year"
								onChange={handleYear}
								value={year}
							/>

							<div className={styles['scaled-clear-filter']}>
								<ClearFilter clearFilter={clearFilter} />
							</div>
						</Space>
					</Col>

					<Col>
						{/* Empty for now — reserve this for action buttons like Export/Sync/Create */}
					</Col>
				</Row>

				{/* <Row justify="space-between">
					<Col>
						<Space>
							<Input
								className={styles['search-filter__search']}
								placeholder="Search here..."
								style={{ fontSize: '12px', minHeight: '40px' }}
								suffix={<SearchOutlined />}
								onChange={(e) => {
									handleChangeSearchValue(e.target.value);
								}}
								value={searchValue}
								size="large"
							/>
							<Select
								className={styles['search-filter__filter']}
								style={{ width: 200 }}
								size="large"
								placeholder="Status"
								showSearch
								value={filterValue?.status}
								filterOption={(input, option: any) =>
									(option?.children as string)
										.toLowerCase()
										.indexOf(input.toLowerCase()) >= 0
								}
								onChange={(value) => performFilterHandler('status', value)}
							>
								<Select.Option value="">Select Status</Select.Option>
								<Select.Option value={EJournalStatus.PUBLISHED}>
									Published
								</Select.Option>
								<Select.Option value={EJournalStatus.DRAFT}>
									Draft
								</Select.Option>
								<Select.Option value={EJournalStatus.DELETED}>
									Deleted
								</Select.Option>
							</Select>
							{/* <PayPeriodFilter
								payPeriodId={selectedPayPeriod}
								onChangePayPeriodId={(value) => {
									onChangePayPeriod(value);
								}}
							/> */}
				{/* <DatePicker
								size="large"
								picker="year"
								onChange={handleYear}
								value={year}
								clearIcon={false}
							/>
							<div className={styles['scaled-clear-filter']}>
								<ClearFilter clearFilter={clearFilter} />
							</div>{' '}
						</Space>
					</Col>
				</Row> */}
			</div>
		</div>
	);
};

export default SearchAndFilter;
